import React from 'react';
import { Modal, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { Box } from '../UI-CHAKRA/Box';
import { Flex } from '../UI-CHAKRA/Flex';
import { Text } from '../UI-CHAKRA/Text';
import { Button } from '../UI-CHAKRA/Button';
import { ReactComponent as CloseIcon } from '../../assets/images/icons/mevo/ic-exit-rounded-purple.svg';
import { useIsMobile } from '../../helpers/useIsMobile';

interface PbmCancelModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const PbmCancelModal: React.FC<PbmCancelModalProps> = ({ isOpen, onClose, onConfirm }) => {
  const isMobile = useIsMobile();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered={!isMobile}
      motionPreset={isMobile ? 'slideInBottom' : 'scale'}
    >
      <ModalOverlay bg="rgba(0, 0, 0, 0.5)" backdropFilter="blur(2px)" />
      <ModalContent
        maxW={{ base: '100%', md: '500px' }}
        width={{ base: '100%', md: 'auto' }}
        margin={isMobile ? 0 : undefined}
        position={isMobile ? 'fixed' : 'relative'}
        bottom={isMobile ? '0' : undefined}
        left={isMobile ? '0' : undefined}
        right={isMobile ? '0' : undefined}
        borderRadius={isMobile ? '20px 20px 0 0' : '20px'}
        padding={'0px'}
        boxShadow={'0px 0px 20px 7px rgba(0,0,0,0.25)'}
      >
        <Box padding={'24px'} position={'relative'}>
          {isMobile && (
            <Flex justifyContent={'center'} mb={'12px'} mt={'-4px'}>
              <Box width={'48px'} height={'4px'} borderRadius={'full'} backgroundColor={'primary.main'} />
            </Flex>
          )}

          <Box position={'absolute'} top={'20px'} right={'20px'}>
            <CloseIcon onClick={onClose} cursor={'pointer'} />
          </Box>

          <Text fontSize={'20px'} fontWeight={700} color={'#343A40'} mb={'16px'} mt={isMobile ? '8px' : 0}>
            Deseja cancelar?
          </Text>

          <Text fontSize={'14px'} color={'#545C62'} mb={'24px'} lineHeight={'20px'}>
            Ao sair agora, o processo será interrompido e o paciente não receberá informações de desconto.
          </Text>

          <Flex
            gap={'12px'}
            flexDirection={isMobile ? 'column' : 'row'}
            justifyContent={isMobile ? 'stretch' : 'flex-end'}
          >
            <Button
              onClick={onClose}
              order={isMobile ? 0 : 1}
              width={isMobile ? '100%' : 'auto'}
              padding="10px 20px"
              backgroundColor={'primary.main'}
              borderRadius={'20px'}
              _hover={{ backgroundColor: '#6B409C' }}
            >
              <Text fontSize={'14px'} color={'#FFF'}>
                Voltar
              </Text>
            </Button>
            <Button
              onClick={onConfirm}
              order={isMobile ? 1 : 0}
              width={isMobile ? '100%' : 'auto'}
              padding="10px 20px"
              backgroundColor={'#FFF'}
              borderWidth={'2px'}
              borderColor={'primary.main'}
              borderStyle={'solid'}
              borderRadius={'20px'}
              _hover={{ backgroundColor: '#FFF', borderColor: '#6B409C' }}
            >
              <Text fontSize={'14px'} color={'primary.main'}>
                Sim, cancelar
              </Text>
            </Button>
          </Flex>
        </Box>
      </ModalContent>
    </Modal>
  );
};

export default PbmCancelModal;
